import { ReactElement } from "react";

import FilesProvider from "../../providers/files-provider";
import CategoriesFilter from "../../sections/files/categories-filter";
import FileListOperators from "../../sections/files/file-list-operators";
import FilesFilters from "../../sections/files/files-filters";
import FilesList from "../../sections/files/files-list";

export default function Files(): ReactElement {
  return (
    <FilesProvider>
      <FileListOperators />
      <div className="flex w-full flex-row gap-[25px] items-start">
        <CategoriesFilter />
        <div className="shadow rounded-[15px] p-50 bg-white gap-[20px] basis-[100%] flex-wrap flex">
          <FilesFilters />
          <FilesList />
        </div>
      </div>
    </FilesProvider>
  );
}
